import { useStore } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { removeAuthToken } from '@/helpers/API';
import { postLogout } from '@/helpers/Requester';
import { modalManager } from '@/libs/ModalContainer';

const useAuth = () => {
  const navigate = useNavigate();
  const store = useStore();

  // 로그아웃
  const doLogout = () => {
    postLogout();
    removeAuthToken();
    navigate('/', { replace: true });

    // 리듀서 상태 초기화
    store.resetAll();

    modalManager.hide();
  };

  return {
    doLogout,
  };
};

export default useAuth;
